<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
      <div style="display: flex; justify-content: flex-end;">
          <v-menu offset-y v-if="
            user.role.roleName != 'WAREHOUSE_MANAGER' &&
            user.role.roleName != 'WAREHOUSE_STAFF'"
          >
            <template v-slot:activator="{on,attrs}">
              <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              >
                <v-icon>add_circle</v-icon>Add
              </v-btn>
            </template>
            <v-list>
              <v-list-tile @click="onRegister">
                <v-list-tile-content>
                  <v-list-tile-title>ADD NEW</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>

              <v-list-tile @click="openDialog = true">
                <v-list-tile-content>
                  <v-list-tile-title>IMPORT EXCEL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>

          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="success"
                :loading="buttonLoading"
                v-bind="attrs"
                v-on="on"
                ><v-icon>cloud_download</v-icon>Export</v-btn
              >
            </template>

            <v-list>
              <v-list-tile @click="exportAllSupplier()">
                <v-list-tile-content>
                  <v-list-tile-title>EXPORT ALL</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
      
          <v-btn @click="showFilters = !showFilters" color="#FF4545">
            <v-icon>filter_list</v-icon>Filter
            <v-icon>{{ showFilters ? 'arrow_drop_up' : 'arrow_drop_down' }}</v-icon>
          </v-btn>
        </div>
      </v-flex>
      <v-flex xs12 v-if="showFilters">
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm4>
              <v-text-field
                name="companyName"
                label="Company Name"
                type="text"
                v-model="queryParams.companyName"
              ></v-text-field>
            </v-flex>
            <v-flex sm4>
              <v-select
                :items="creditLevelList"
                v-model="queryParams.creditLevelIds"
                label="Choose Credit Level"
                item-text="name"
                item-value="id"
                menu-props="auto"
                multiple
                small-chips
              ></v-select>
            </v-flex>
            <v-flex sm4>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :must-sort="true"
            :headers="headers"
            :items="supplierList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            >
            <template slot="items" slot-scope="props">
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.companyName }}</td>
              <td>{{ props.item.supplierType }}</td>
              <td>{{ props.item.warehouseName }}</td>
              <td>{{ props.item.creditLevelName }}</td>
              <td>{{ props.item.address }}</td>
              <td>{{ props.item.phone }}</td>
              <td>{{ props.item.email }}</td>
              <td>{{ props.item.contactPerson }}</td>
              <td>{{ props.item.createdDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.createdBy }}</td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <supplierExcel :isOpen="openDialog" v-on:change="dialogClose()"></supplierExcel>
  </v-container>
</template>

<script>
import { creditLevelService } from '../../services/credit-level-service';
import { supplierService } from "../../services/supplier-service";
import { commonService } from "../../services/common-service";
import supplierExcel from "./SupplierExcel";

export default {
  name: "SupplierList",

  components: { supplierExcel },
  data: () => ({
    user: JSON.parse(localStorage.getItem("user")),
    buttonLoading: false,
    showListLoading: false,
    showFilters: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Supplier",
        disabled: true
      }
    ],
    creditLevelList: [],
    headers: [
      { text: "Action", value: "name", sortable: false },
      { text: "Code", value: "code" },
      { text: "Company Name", value: "companyName" },
      { text: "Type", value: "type" , sortable: false},
      { text: "Warehouse", value: "warehouse" , sortable: false },
      { text: "Credit Level", value: "Credit Level" , sortable: false },
      { text: "Address", value: "address" },
      { text: "Phone No.", value: "phone" },
      { text: "Email", value: "email" },
      { text: "Contact Person", value: "contact_person" },
      { text: "Created Date", value: "createdDate" },
      { text: "Created By", value: "createdBy" },
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "createdDate",
      totalItems: 0
    },
    supplierList: [],
    totalRows: 0,
    queryParams: {
      companyName: "",
      creditLevelIds: [],
    },
    openDialog: false
  }),
  watch: {
    pagination: {
      handler() {
        this.getSupplierList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.companyName) {
      this.queryParams.companyName = this.$route.query.companyName;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.getCreditLevels();
  },
  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({
        name: "suppliers",
        query: this.queryParams
      });
      this.getSupplierList();
    },
    getCreditLevels() {
      creditLevelService
        .getCreditLevels()
        .then(res => {
          if (res.data) {
            this.creditLevelList = res.data.creditLevelList;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSupplierList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      supplierService
        .getSupplierList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.supplierList = res.data.supplierList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/supplier/new");
    },
    onEdit(supplier) {
      // go to details page
      this.$router.push("/supplier/" + supplier.id);
    },
    exportAllSupplier() {
      this.buttonLoading = true;
      supplierService
         .getSupplierExcelExport(this.queryParams)
         .then((res) => {
           commonService.downloadE(res);
         })
         .catch((err) => {
           console.log(err);
         });
       this.buttonLoading = false;
    },
    dialogClose() {
      this.openDialog = false;
      this.getSupplierList();
    },
  }
};
</script>